import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { SERVICE_REQUEST_PAYMENT_INPUT, ServiceRequestPaymentInputState } from './service-request-payment-input.state';
import { serviceRequestPaymentInputReducer } from './service-request-payment-input.reducer';

/** Token of the ServiceRequestPaymentInput reducer */
export const SERVICE_REQUEST_PAYMENT_INPUT_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<ServiceRequestPaymentInputState, Action>
>('Feature ServiceRequestPaymentInput Reducer');

/** Provide default reducer for ServiceRequestPaymentInput store */
export function getDefaultServiceRequestPaymentInputReducer() {
  return serviceRequestPaymentInputReducer;
}

@NgModule({
  imports: [StoreModule.forFeature(SERVICE_REQUEST_PAYMENT_INPUT, SERVICE_REQUEST_PAYMENT_INPUT_REDUCER_TOKEN)],
  providers: [
    {
      provide: SERVICE_REQUEST_PAYMENT_INPUT_REDUCER_TOKEN,
      useFactory: getDefaultServiceRequestPaymentInputReducer,
    },
  ],
})
export class ServiceRequestPaymentInputStoreModule {
  public static forRoot<T extends ServiceRequestPaymentInputState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<ServiceRequestPaymentInputStoreModule> {
    return {
      ngModule: ServiceRequestPaymentInputStoreModule,
      providers: [{ provide: SERVICE_REQUEST_PAYMENT_INPUT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
